export default __webpack_public_path__ + "static/media/vote_logo.38cb0e33.svg";